import { Component } from '@angular/core';

@Component({
  selector: 'app-inactive-link',
  templateUrl: './inactive-link.component.html',
  styleUrls: ['./inactive-link.component.scss'],
  standalone: false
})
export class InactiveLinkComponent {}
